import { useState, useCallback, useEffect } from 'react';
import { billApi } from '@api';
import { IOrderBill } from '@root/types/bill';

const pageSize = 20;

const useBillList = (): {
  list: IOrderBill[];
  loading: number;
  isMoreData: boolean;
  onMoreData: () => void;
  getList: () => void;
} => {
  const [loading, setLoading] = useState(-1);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [list, setList] = useState<IOrderBill[]>([]);

  const getList = useCallback(() => {
    setLoading(0);

    billApi
      .getPageOrderList({ pageNum, pageSize, orderStatus: '' })
      .then((data: any) => {
        const _list = data?.list || [];
        setList((v) => [...v, ..._list]);
        setTotal(data?.total);
        setLoading(1);
      })
      .catch(() => {
        setLoading(2);
      });
  }, [pageNum]);

  const isMoreData = list.length < total;

  const onMoreData = useCallback(() => {
    if (loading === 0) {
      return;
    }
    if (isMoreData) {
      setPageNum((v) => v + 1);
    }
  }, [isMoreData, loading]);

  useEffect(() => {
    getList();
  }, [getList]);

  return {
    list,
    loading,
    isMoreData,
    onMoreData,
    getList,
  };
};

export default useBillList;
